import { XMLInterfaceObject } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { VisualVO } from "./VisualVO";

export class TitlesVO extends VisualVO {
    // @ts-ignore // constructor hack
    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }
    public name: string;
    public level: number = 0;

    public fillFromParamXML(wodElement: XMLInterfaceObject): void {
        super.fillFromParamXML(wodElement);
        this.name = (wodElement['name'] || '');
        this.level = int((wodElement['level'] || ''));
    }
}
classImplementsInterfaces(TitlesVO, "IInventoryVO");
